import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "IBMPlexSans";
        src: url("/fonts/IBMPlexSans-VariableFont_wdth,wght.ttf") format("truetype");
        font-style: normal;
        font-display: swap;
    }

    body,
    html,
    a {
        font-family: 'IBMPlexSans', sans-serif;
    }

    html {
        overflow-x: hidden;
    }

    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        background: #ffffb7;
        overflow-x: hidden;
    }

    a:hover {
        color: #000000;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: #fff;
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: none;
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'IBMPlexSans', serif;
        color: #000000;
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 32px;
        }
    }

    p {
        color: #000000;
        font-size: 21px;        
        line-height: 1.41;
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        color: #000000;

        :hover {
            color: #000000;
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }
`;
